import { render, staticRenderFns } from "./batchStatistics.vue?vue&type=template&id=d3526784"
import script from "./batchStatistics.vue?vue&type=script&lang=js"
export * from "./batchStatistics.vue?vue&type=script&lang=js"
import style0 from "./batchStatistics.vue?vue&type=style&index=0&id=d3526784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports